import styled from "styled-components";

import Spring from "../../components/Spring";

export const StyledSignup = styled(Spring)`
    overflow: hidden;
    background-color: ${p => p.theme.c.snow};
    min-height: calc(100vh - 50px);
`;

export const StyledRecaptcha = styled.div`
    width: 302px;
    margin: auto;
    margin-bottom: 16px;

    @media screen and (max-width: 359px) {
        width: 100%;
    }

    > div {
        margin: auto;
    }

    &.RecaptchaDisabled {
        pointer-events: none;
    }
`;
